import(/* webpackMode: "eager", webpackExports: ["CookieBanner"] */ "C:\\Users\\Administrator\\Documents\\GitHub\\pione-group-v2\\src\\components\\fragments\\cookie-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Administrator\\Documents\\GitHub\\pione-group-v2\\src\\components\\sections\\footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "C:\\Users\\Administrator\\Documents\\GitHub\\pione-group-v2\\src\\components\\sections\\navbar.tsx");
